import palette from './palette';
import breakpoints from './breakpoints';
import getTypography from './typography';
import spacing from './spacing';
import radius from './radius';
import shadows from './shadows';
import shape from './shape';
import containerQueries from './containerQueries';

const typography = getTypography({ breakpoints });

export default {
  containerQueries,
  breakpoints,
  palette,
  typography,
  shape,
  spacing,
  radius,
  shadows,
};
